var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4591_3755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1156 14.5427C17.9763 15.6013 17.4564 16.573 16.6531 17.2764C15.8497 17.9797 14.8177 18.3665 13.75 18.3646C7.54688 18.3646 2.50001 13.3177 2.50001 7.11459C2.49809 6.04685 2.88492 5.01492 3.58824 4.21154C4.29155 3.40816 5.26326 2.88827 6.32188 2.74896C6.58958 2.71628 6.86067 2.77104 7.09468 2.90509C7.3287 3.03913 7.51309 3.24526 7.62032 3.49271L9.27032 7.17631V7.18568C9.35242 7.3751 9.38633 7.5819 9.36901 7.78762C9.3517 7.99333 9.2837 8.19156 9.1711 8.36459C9.15704 8.38568 9.14219 8.40521 9.12657 8.42474L7.50001 10.3529C8.08516 11.5419 9.32891 12.7747 10.5336 13.3615L12.4352 11.7435C12.4538 11.7278 12.4734 11.7132 12.4938 11.6997C12.6666 11.5844 12.8655 11.514 13.0725 11.4949C13.2794 11.4759 13.4878 11.5086 13.6789 11.5904L13.6891 11.5951L17.3695 13.2443C17.6174 13.3511 17.8241 13.5354 17.9585 13.7694C18.093 14.0034 18.1481 14.2747 18.1156 14.5427Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4591_3755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.864502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.f1991cb1f97f9b5bc227c5d5cec1ded8.svg";
export { ForwardRef as ReactComponent };